module.exports = __webpack_public_path__ + "static/media/pops-strawberry-chocolate.e488db58.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/ourProducts/products/nutrition-facts/pops-strawberry-chocolate.png
// module id = 191
// module chunks = 0